import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return () => present(repository.getResourcesTags());
}

export type { Interactor };

export { createInteractor };
